export const EventType = {
    AGENT_HANDOVER: 'AGENT_HANDOVER',
}